// Receipts never grant permission or mark an email completed. Server receipts
// are revalidated against both current sources; local receipts bridge refresh.
export function emailViewRevision(mail) {
  return JSON.stringify(["id","user_id","org_id","sender","sender_name","subject","snippet","body","received_at","stale","category"].map(key=>mail[key]??null));
}

export function matchingEmailCompletion(row,completions) {
  const receipt=completions[row.id];
  return row.kind==="email"&&receipt?.revision===row.view_revision?receipt:null;
}

export function emailCompletionNote(actionType) {
  if(actionType==="email_attention_ack")return "Vain etusivun huomioasia kuitattiin. Sähköposti ja mahdollinen vastaustarve säilyvät ennallaan. Tilin turvallisuutta ei tarkistettu.";
  return actionType==="email_draft"
    ?"Luonnos ei ole lähetetty. Viesti säilyy Postissa ja mahdollinen vastaustarve pysyy erillisenä."
    :"Kalenterimuutos ei vastannut sähköpostiin. Viesti ja sen mahdollinen vastaustarve säilyvät Postissa.";
}

export function readSolutionReceipts(value,emails) {
  if(value===undefined)return undefined; // Older backend: view-local only.
  const unavailable={available:false,limited:false,items:[]};
  if(value?.scope!=="personal_solution_receipts_v1"||value.read_only!==true||typeof value.available!=="boolean"||typeof value.limited!=="boolean"||!Array.isArray(value.items)||value.items.length>20||!Number.isFinite(Date.parse(value.checked_at)))return unavailable;
  if(!value.available)return unavailable;
  const seen=new Set();const items=[];
  for(const receipt of value.items){
    const mail=emails.find(row=>row.id===receipt?.email_id);
    const kind=receipt?.action_type;
    if(!mail||seen.has(mail.id)||receipt.verified!==true||!["calendar_event_update","email_draft","email_attention_ack"].includes(kind)||typeof receipt.target_id!=="string"||!receipt.target_id||receipt.target_id.length>300||kind!=="calendar_event_update"&&receipt.target_id!==mail.id||!Number.isFinite(Date.parse(receipt.saved_at))||Date.parse(receipt.saved_at)>Date.parse(value.checked_at))return unavailable;
    let path;try{path=kind==="calendar_event_update"?`/calendar?event=${encodeURIComponent(receipt.target_id)}`:`/inbox?email=${encodeURIComponent(receipt.email_id)}`;}catch{return unavailable;}
    if(receipt.target_path!==path)return unavailable;
    seen.add(mail.id);items.push({email_id:mail.id,revision:emailViewRevision(mail),actionType:kind,savedAt:Date.parse(receipt.saved_at),persistent:true,message:kind==="email_attention_ack"?"Kuitattu: ei tarvitse huomiota.":kind==="email_draft"?"Vastausluonnos on tallessa. Viestiä ei lähetetty.":"Hyväksytty kalenterimuutos on tallessa."});
  }
  return {available:true,limited:value.limited,checkedAt:Date.parse(value.checked_at),items};
}

export function effectiveEmailCompletions(local,state) {
  if(state===undefined)return local;
  if(!state.available||!Array.isArray(state.items)||!Number.isFinite(state.checkedAt))return {};
  const verified=Object.fromEntries(state.items.map(row=>[`email:${row.email_id}`,row]));
  // A later authoritative read can invalidate a receipt whose target changed.
  for(const [id,receipt] of Object.entries(local))if(receipt.savedAt>state.checkedAt)verified[id]=receipt;
  return verified;
}
